import * as yup from 'yup';

export const tenantSchema = yup.object().shape({
    name: yup.string().required('Requis'),
    azureDomain: yup.string().required('Requis'),
    ozmoCode: yup.string().required('Requis'),
});